/*
 * Swatch & product link prefetcher (2026-05-19)
 * Doel: kleurwissel op PDP en product cards "voelt instant".
 * Werkt door <link rel="prefetch"> dynamisch toe te voegen bij hover/touch/focus.
 *
 * Strategie:
 *  - Skip op slow-2g/2g/save-data verbindingen (geen bandbreedte verspilling)
 *  - Max 12 prefetches per page-view (cap)
 *  - Hover/touchstart/focusin op a[href*="/products/"] of a[href*="/collections/"]
 *  - Op PDP: auto-prefetch alle a.color-swatch links na page idle
 */
(function () {
  'use strict';

  var conn = navigator.connection;
  if (conn && (conn.saveData || /^(slow-2g|2g)$/.test(conn.effectiveType || ''))) return;

  var prefetched = new Set();
  var MAX = 12;

  function prefetch(url) {
    if (!url || prefetched.has(url) || prefetched.size >= MAX) return;
    try {
      var u = new URL(url, location.origin);
      if (u.pathname === location.pathname) return;
      if (u.origin !== location.origin) return;
      prefetched.add(u.href);
      var link = document.createElement('link');
      link.rel = 'prefetch';
      link.as = 'document';
      link.href = u.href;
      document.head.appendChild(link);
    } catch (e) {}
  }

  function prefetchFromEvent(e) {
    if (!e.target || !e.target.closest) return;
    var a = e.target.closest('a[href*="/products/"], a[href*="/collections/"]');
    if (!a) return;
    prefetch(a.href);
  }

  document.addEventListener('mouseover', prefetchFromEvent, { passive: true });
  document.addEventListener('touchstart', prefetchFromEvent, { passive: true });
  document.addEventListener('focusin', prefetchFromEvent, { passive: true });

  // Auto-prefetch color swatches on PDP after idle
  if (location.pathname.indexOf('/products/') !== -1) {
    var run = function () {
      var swatches = document.querySelectorAll('a.color-swatch[href*="/products/"]');
      swatches.forEach(function (a) { prefetch(a.href); });
    };
    if (window.requestIdleCallback) {
      window.requestIdleCallback(run, { timeout: 2500 });
    } else {
      setTimeout(run, 1800);
    }
  }
})();
